// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/components/QuestionSelect.tsx

import type { Ref } from "react";
import type { SelectOption } from "../types";

type QuestionSelectProps = {
  label: string;
  value: string;
  options: SelectOption[];
  disabled: boolean;
  helperText?: string;
  selectId?: string;
  selectRef?: Ref<HTMLSelectElement>;
  onChange: (value: string) => void;
};

export default function QuestionSelect({
  label,
  value,
  options,
  disabled,
  helperText,
  selectId,
  selectRef,
  onChange,
}: QuestionSelectProps) {
  return (
    <label>
      <span>{label}</span>
      <select
        id={selectId}
        ref={selectRef}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {helperText ? <small>{helperText}</small> : null}
    </label>
  );
}
